import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Clinics from './pages/Clinics';
import ClinicDetail from './pages/ClinicDetail';
import Conversations from './pages/Conversations';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import ToolBox from './pages/ToolBox';
import DoctorScheduleGenerator from './pages/DoctorScheduleGenerator';
import DoctorScheduleImporter from './pages/DoctorScheduleImporter';
import DoctorImporterNoSchedule from './pages/DoctorImporterNoSchedule';
import DoctorServiceUpdater from './pages/DoctorServiceUpdater';
import DoctorScheduleEditor from './pages/DoctorScheduleEditor';
import ServiceDoctorQAGenerator from './pages/ServiceDoctorQAGenerator';
import QAKnowledgeBaseGenerator from './pages/QAKnowledgeBaseGenerator';
import ConversationMessagesTool from './pages/ConversationMessagesTool';
import ConversationMessagesImport from './pages/ConversationMessagesImport';
import ConversationStateEventImport from './pages/ConversationStateEventImport';
import FindDocAgentAnalytics from './pages/FindDocAgentAnalytics';
import HKSHReportGenerator from './pages/HKSHReportGenerator';
import OncoCareSurveyReport from './pages/OncoCareSurveyReport';
import FlexibleExtract from './pages/FlexibleExtract';
import MediaBulkUploadTool from './pages/MediaBulkUploadTool';
import WatiContactSegmentSync from './pages/WatiContactSegmentSync';
import ActionItems from './pages/ActionItems';
import Onboarding from './pages/Onboarding';
import OnboardingTokens from './pages/OnboardingTokens';
import ClinicIntegrationEvents from './pages/ClinicIntegrationEvents';
import MetaWhatsappEvents from './pages/MetaWhatsappEvents';
import PhoneNumberSearch from './pages/PhoneNumberSearch';
import Login from './pages/Login';
import Register from './pages/Register';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToolBoxProvider } from './contexts/ToolBoxContext';
import { I18nProvider } from './contexts/I18nContext';

// Custom redirect component that checks authentication
const AuthRedirect = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <I18nProvider>
        <ToolBoxProvider>
          <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/clinics" element={<Layout><Clinics /></Layout>} />
          <Route path="/clinics/:clinicId" element={<Layout><ClinicDetail /></Layout>} />
          <Route path="/clinics/:clinicId/conversations" element={<Layout><Conversations /></Layout>} />
          <Route path="/action-items" element={<Layout><ActionItems /></Layout>} />
          <Route path="/onboarding" element={<Layout><Onboarding /></Layout>} />
          <Route path="/onboarding-tokens" element={<Layout><OnboardingTokens /></Layout>} />
          <Route path="/clinic-integration-events" element={<Layout><ClinicIntegrationEvents /></Layout>} />
          <Route path="/meta-whatsapp-events" element={<Layout><MetaWhatsappEvents /></Layout>} />
          <Route path="/phone-search" element={<Layout><PhoneNumberSearch /></Layout>} />
          <Route path="/settings" element={<Layout><Settings /></Layout>} />
          <Route path="/toolbox" element={<Layout><ToolBox /></Layout>} />
          <Route path="/toolbox/doctor-schedule-generator" element={<Layout><DoctorScheduleGenerator /></Layout>} />
          <Route path="/toolbox/qa-knowledge-base-generator" element={<Layout><QAKnowledgeBaseGenerator /></Layout>} />
          <Route path="/toolbox/doctor-schedule-importer" element={<Layout><DoctorScheduleImporter /></Layout>} />
          <Route path="/toolbox/doctor-importer-no-schedule" element={<Layout><DoctorImporterNoSchedule /></Layout>} />
          <Route path="/toolbox/doctor-service-updater" element={<Layout><DoctorServiceUpdater /></Layout>} />
          <Route path="/toolbox/doctor-schedule-editor" element={<Layout><DoctorScheduleEditor /></Layout>} />
          <Route path="/toolbox/service-doctor-qa-generator" element={<Layout><ServiceDoctorQAGenerator /></Layout>} />
          <Route path="/toolbox/conversation-messages" element={<Layout><ConversationMessagesTool /></Layout>} />
          <Route path="/toolbox/conversation-messages-import" element={<Layout><ConversationMessagesImport /></Layout>} />
          <Route path="/toolbox/conversation-state-events-import" element={<Layout><ConversationStateEventImport /></Layout>} />
          <Route path="/toolbox/finddoc-agent-analytics" element={<Layout><FindDocAgentAnalytics /></Layout>} />
          <Route path="/toolbox/hksh-report" element={<Layout><HKSHReportGenerator /></Layout>} />
          <Route path="/toolbox/oncocare-survey-report" element={<Layout><OncoCareSurveyReport /></Layout>} />
          <Route path="/toolbox/flexible-extract" element={<Layout><FlexibleExtract /></Layout>} />
          <Route path="/toolbox/media-bulk-upload" element={<Layout><MediaBulkUploadTool /></Layout>} />
          <Route path="/toolbox/wati-contact-segment-sync" element={<Layout><WatiContactSegmentSync /></Layout>} />
        </Route>

        {/* Fallback route - redirect to login if not authenticated */}
        <Route path="*" element={<AuthRedirect />} />
        </Routes>
        </ToolBoxProvider>
      </I18nProvider>
    </AuthProvider>
  );
}

export default App;
